import moment from "moment/moment";
import i18n from "../locales/i18n";
import "moment/locale/ko";
import "moment/locale/ja";

moment.locale(i18n.resolvedLanguage);

export default moment;
